import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import AnalysisPageBase from './AnalysisPageBase';
import { ApiProvider } from '../../types';
import { analyzeImageWithGrok } from '../../services/grokService';

const AnalyzeGrokPage: React.FC = () => {
  return (
    <AnalysisPageBase
      apiProvider={ApiProvider.GROK}
      analyzeFunction={analyzeImageWithGrok}
      pageTitle="Grok-4 Vision Analysis"
      pageDescription="Use xAI's advanced Grok-4 vision model to get comprehensive product analysis and market insights."
      icon={SparklesIcon}
    />
  );
};

export default AnalyzeGrokPage;
